function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
const FieldLabel = tw.label`
  ${({ $color, $size, $margin })=>{
    return `
      flex
      flex-row
      justify-between
      items-center

      mb-2
      ${$margin ? `${$margin}` : ""}

      pl-1
      w-full
      ${$color !== null && $color !== void 0 ? $color : "text-white"}
      ${!$color ? "text-opacity-70" : ""}
      ${`text-${$size || "sm"}`}
    `;
}}
`;
const SLabel = ({ children, color, size = "sm", margin = "", htmlFor = undefined })=>{
    const props = {
        $color: color,
        $size: size,
        $margin: margin,
        htmlFor: htmlFor
    };
    return /*#__PURE__*/ _jsx(FieldLabel, _object_spread_props(_object_spread({}, props), {
        children: children
    }));
};
const Container = tw.div`
  flex
  flex-col
  relative
  ${(p)=>p.$noMargin ? "" : "mb-3"}
  w-full
`;
const SField = ({ children, noMargin = false })=>{
    return /*#__PURE__*/ _jsx(Container, {
        $noMargin: noMargin,
        children: children
    });
};
SField.Label = SLabel;
export { SField };
